<template lang="pug">
span
  .md-layout
    .md-layout-item.md-size-100.mx-auto(style='padding: 0')
      SearchMessagesTable(
        ref='chat-table-reference'
        :title="$t('searchMessages.searchResult')"
        :process-time='processTime')
  GlobalDialog(
    v-model='filterDialog'
    max-width='700px'
    scrollable
    :headerTitle="$t('searchMessages.filter')"
    showMButton
    mButtonTextColor='#FE544F'
    mButtonColor='#FE544F'
    mButtonIsOutlined
    :mButtonTitle="$t('searchMessages.reset')"
    @clickMButton='resetFilter()'
    showRButton
    :rButtonTitle="$t('searchMessages.toApply')"
    @clickRButton='saveFilter()')
    template(v-slot:content)
      ChatHistoryFilter(:key='resetKey')
</div>
</template>

<script>
import moment from 'moment'
import SearchMessagesTable from '@/components/SearchMessages/Search.vue'
import GlobalDialog from '@/components/Reuse/GlobalDialog'
import ChatHistoryFilter from '@/components/Filters/ChatHistoryFilter'
import { mapFields } from 'vuex-map-fields'

export default {
  components: {
    SearchMessagesTable,
    GlobalDialog,
    ChatHistoryFilter
  },
  computed: {
    ...mapFields('chatHistoryFilter', ['protocol', 'user_name', 'cpf', 'phone', 'bot', 'channelFilter', 'evaluationFilter', 'intentFilter'])
  },
  data () {
    return {
      filterDialog: false,
      createButton: require('@/../public/img/plus.png'),
      resetKey: 0,
      processTime: moment().format('YYYY-MM-DD[T]HH:mm:ssZ')
    }
  },
  methods: {
    saveFilter () {
      this.filterDialog = false
      this.$refs['chat-table-reference'].changeFilters()
    },
    resetFilter () {
      this.protocol = undefined
      this.user_name = undefined
      this.cpf = undefined
      this.phone = undefined
      this.bot = undefined
      this.channelFilter = undefined
      this.evaluationFilter = undefined
      this.intentFilter = undefined
      this.resetKey++
      this.saveFilter()
    }
  }
}
</script>
